





























import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import FileFolder from 'components/presenter/item/FileFolder.vue'
import { Item } from 'src/graphql/types'

@Component({
  components: {
    FileFolder
  }
})
export default class ItemFileInput extends Vue {
  src = ''

  @Prop()
  readonly item!: Item

  @Prop({ default: '' })
  readonly value!: string

  @Prop()
  readonly accept!: string

  @Ref()
  readonly folder!: FileFolder

  get name () {
    return this.src.match(/^(\/\d+)+\/.{36}\.(?<name>.+)/)?.groups?.name
  }

  @Watch('value', { immediate: true })
  setSrc (value: string) {
    this.src = value || ''
  }

  updateSrc (src: string) {
    this.src = src || ''
    this.$emit('input', this.src)
  }

  fileSelect (file: Json) {
    this.folder.hide()
    this.updateSrc(file.src)
  }
}
